export default __webpack_public_path__ + "static/custom-cool-crm-da9faa849d47048581a65bce16f46da7.png";